"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarMenuItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _SidebarMenuItem = require("./SidebarMenuItem.styled");
var _Reusable = require("../../constants/Reusable");
var SidebarMenuItem = exports.SidebarMenuItem = function SidebarMenuItem(_ref) {
  var isActive = _ref.isActive,
    icon = _ref.icon,
    iconColor = _ref.iconColor,
    children = _ref.children,
    onClick = _ref.onClick,
    menuItemId = _ref.menuItemId,
    enableFeature = _ref.enableFeature;
  return /*#__PURE__*/_react["default"].createElement(_SidebarMenuItem.MenuItemWraper, {
    "data-testid": menuItemId,
    isActive: isActive,
    onClick: onClick,
    id: menuItemId,
    enableFeature: enableFeature,
    onKeyDown: function onKeyDown(e) {
      return (0, _Reusable.handleEnterDown)(e, onClick);
    },
    tabIndex: "0"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: icon,
    color: iconColor || (isActive ? '#0095FF' : '#fff')
  }), children);
};
SidebarMenuItem.propTypes = {
  isActive: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  icon: _propTypes["default"].object,
  iconColor: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  menuItemId: _propTypes["default"].string.isRequired,
  enableFeature: _propTypes["default"].bool
};